// extracted by mini-css-extract-plugin
export var section = "section-module--section--3zvds";
export var container = "section-module--container--1_AaT";
export var title = "section-module--title--1uOD7";